import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { createTrackableProps } from "@xo-union/tk-component-analytics";
import { NewWindowAnchor } from "@xo-union/component-standard-elements";
import { IconLink } from "@xo-union/tk-component-icons";
import styles from "../../../../../css/index.css";
const SocialIcon = _ref => {
  let {
    name
  } = _ref;
  return /*#__PURE__*/React.createElement(IconLink, _extends({
    as: NewWindowAnchor,
    name: `social_${name}_selected`,
    href: `https://${name}.com/theknot`,
    className: styles.socialIcon,
    size: "md",
    "aria-label": name
  }, createTrackableProps({
    selection: name
  })));
};
process.env.NODE_ENV !== "production" ? SocialIcon.propTypes = {
  name: PropTypes.string.isRequired
} : void 0;
export default SocialIcon;